import { motion } from "framer-motion";
import { MaskLine } from "./motion";

export const PageHeader = ({ overline, title, subtitle }) => {
  return (
    <section data-testid="page-header" className="relative overflow-hidden bg-[#010101] pt-40 pb-20 lg:pt-48 lg:pb-28">
      {/* faint parallax sun arch */}
      <div className="absolute -top-[30vh] right-[-12vw] z-0 w-[60vw] h-[60vw] max-w-[720px] max-h-[720px] pointer-events-none">
        <div className="sa-spin-slow w-full h-full rounded-full border-[3px] border-[#fcc41b]/50 sa-gold-glow" style={{ borderRightColor: "transparent", borderBottomColor: "transparent" }} />
        <div className="absolute inset-[12%] rounded-full bg-[#fcc41b]/[0.04] blur-3xl" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12">
        <MaskLine delay={0.15} className="text-xs sm:text-sm tracking-[0.3em] uppercase text-[#fcc41b] font-display font-medium mb-6">
          {overline}
        </MaskLine>
        <h1 className="font-display font-semibold tracking-tighter leading-[0.92] text-white" style={{ fontSize: "clamp(2.75rem, 7vw, 6rem)" }}>
          <MaskLine delay={0.28}>{title}</MaskLine>
        </h1>
        {subtitle && (
          <motion.p
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, ease: [0.16, 1, 0.3, 1], delay: 0.55 }}
            className="mt-8 text-lg sm:text-xl text-zinc-300 max-w-2xl leading-relaxed"
          >
            {subtitle}
          </motion.p>
        )}
      </div>
    </section>
  );
};
